import { gql, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "src/utils/hook/base/baseserviceindex";
import Cookies from "js-cookie";
import { useContext } from "react";
import { MenuContext } from "src/contexts/menu-context/MenuContext";
import { UserContext } from "src/contexts/UserContext";
import useAAA from "src/utils/hook/base/useAAA";
import useErrorHandling from "src/utils/hook/base/useErrorHandling";
import useRequestConfig from "src/utils/hook/base/useRequestConfig";


const logout = gql`
  mutation deleteTokenCookie ($refresh: String!){
    deleteTokenCookie (refresh: $refresh){
     message
    statusCode

    }
  }
`;

const useLogout = (variables) => {
  const {errorHandling}=useErrorHandling();
  const {setNewTabItems,setNewTabContent,setTab } = useContext(MenuContext);
  const { clearAll } =useContext(UserContext);
  const { clearUserData } = useAAA();
  const {requestConfig}=useRequestConfig();
  const [mutate, { loading }] = useMutation(logout,requestConfig({module:"AVC_AAA",Microservice:"S.AVC.AVC.Bio.logout.Full"}));
  const { snack } = useSnackbar();
  const navigate = useNavigate();

  const performLogout = (data) => {
    mutate({variables: { refresh: Cookies.get("pqwlmakxmcer") },
      onCompleted: (data) => {
        snack.success({
          title: "شما با موفقیت خارج شدید.",
        });
        clearUserData(); 
        clearAll();
        setNewTabItems([]);
        setNewTabContent([]);
        setTab(null);
        navigate("/login");
      },
      onError: (error) => {
        errorHandling();
        clearUserData();
        clearAll();
        setNewTabItems([]);
        setNewTabContent([]);
        setTab(null);
        navigate("/login");

      },
    });
  };
  return { performLogout, loading };
};

export default useLogout;
